import React from 'react';

import { FormattedMessage } from 'react-intl';

import { IconButton } from '@atlaskit/button/new';
import { cssMap, cx } from '@atlaskit/css';
import ArrowLeftIcon from '@atlaskit/icon/core/arrow-left';
import ArrowRightIcon from '@atlaskit/icon/core/arrow-right';
import { Inline } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { CardsAIDisclaimer } from '../../ai-disclaimer';

import { messages } from './messages';

const styles = cssMap({
	footer: {
		justifyContent: 'space-between',
		alignItems: 'center',
		paddingTop: token('space.075'),
	},
	footerNav: {
		marginLeft: 'auto',
		gap: token('space.050'),
	},
	iconBackgroundColor: {
		backgroundColor: token('elevation.surface.overlay'),
		borderRadius: token('radius.full'),
	},
});

type CardsContentFooterProps = {
	allCardsShown: boolean;
	isAtBeginning: boolean;
	isAtEnd: boolean;
	isStacked: boolean;
	scrollToNext: () => void;
	scrollToPrevious: () => void;
	showAIDisclaimer?: boolean;
};

export const CardsContentFooter = ({
	isStacked,
	showAIDisclaimer,
	allCardsShown,
	isAtBeginning,
	isAtEnd,
	scrollToPrevious,
	scrollToNext,
}: CardsContentFooterProps): React.JSX.Element | null => {
	const showFooter = showAIDisclaimer || (!isStacked && !allCardsShown);

	if (!showFooter) {
		return null;
	}

	return (
		<Inline
			space="space.050"
			testId="link-cards-content-cards-row-navigation"
			xcss={cx(styles.footer, isStacked && !showAIDisclaimer && styles.footerNav)}
		>
			{showAIDisclaimer && <CardsAIDisclaimer />}
			{!isStacked && !allCardsShown && (
				<Inline xcss={styles.footerNav}>
					<Inline xcss={styles.iconBackgroundColor}>
						<IconButton
							shape="circle"
							icon={ArrowLeftIcon}
							isDisabled={isAtBeginning}
							label={<FormattedMessage {...messages.previous} />}
							onClick={scrollToPrevious}
						/>
					</Inline>
					<Inline xcss={styles.iconBackgroundColor}>
						<IconButton
							shape="circle"
							icon={ArrowRightIcon}
							isDisabled={isAtEnd}
							label={<FormattedMessage {...messages.next} />}
							onClick={scrollToNext}
						/>
					</Inline>
				</Inline>
			)}
		</Inline>
	);
};
